import { render, staticRenderFns } from "./basicDataTotal.vue?vue&type=template&id=9671784e&scoped=true"
import script from "./basicDataTotal.vue?vue&type=script&lang=js"
export * from "./basicDataTotal.vue?vue&type=script&lang=js"
import style0 from "./basicDataTotal.vue?vue&type=style&index=0&id=9671784e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9671784e",
  null
  
)

export default component.exports